import React, { type CSSProperties } from 'react';
import cn from 'classnames';
import { dynamic } from 'src/helpers/dynamic';

import HotelMapLoader from 'src/components/YandexMap/components/HotelMapLoader';
import type { LazyYandexHotelMapProps } from './types';
import styles from './lazyYandexHotelMap.module.css';

const YandexHotelMap = dynamic(
  () => import(/* webpackChunkName: "YandexHotelMap" */ './YandexHotelMap'),
);

const LazyYandexHotelMap: React.FC<Readonly<LazyYandexHotelMapProps>> = (
  props,
) => {
  const { isMobile, height, className } = props;
  const [isMapLoading, setIsMapLoading] = React.useState(true);
  const containerClassName = cn(styles.container, {
    [styles.mobileContainer]: isMobile,
  });
  return (
    <div style={{ '--height': `${height}` } as CSSProperties}>
      {isMapLoading && <HotelMapLoader className={className} />}
      <YandexHotelMap
        className={cn(className, containerClassName)}
        setIsMapLoading={setIsMapLoading}
        {...props}
      />
    </div>
  );
};

export default LazyYandexHotelMap;
